export default {"src":"/_next/static/media/Outdoorsy-GITW-2024.691cc749.gif","height":630,"width":1200,"blurWidth":0,"blurHeight":0};